import { useCallback, useEffect, useState } from "react"
import { getRadioList } from "../../services/radioApis"
import MyModal from "../MyModal"
import { toast } from "react-toastify"
import { changeBotPlaying } from "../../services/botApis"
import { useSocket, useSocketEvent } from "../../contexts/SocketContext"

const SelectRadioModal = ({ bot, user }) => {
    const [isOpen, setIsOpen] = useState(false)
    const { isConnected, sendMessage } = useSocket()

    const [radioList, setRadioList] = useState([])

    const handleRadioList = useCallback((data) => setRadioList(data))

    useSocketEvent("radioList", handleRadioList)

    useEffect(() => {
        if (isOpen && isConnected) {
            sendMessage("getRadioList")
        }
    }, [isOpen, isConnected])

    const toggleModal = () => {
        setIsOpen(!isOpen)
    }

    return (
        <>
            <button
                onClick={toggleModal}
                style={{ backgroundColor: "#3B82F6" }}
                className="flex justify-center border  bg-slate-500 text-white rounded-3xl px-4 py-2 m-2 transition duration-500 ease select-none hover:bg-slate-600 focus:outline-none focus:shadow-outline"
            >
                <img src="assets/icons/music.svg" className="w-5 h-5 text-black" />
                انتخاب رادیو
            </button>
            <MyModal isOpen={isOpen} toggleModal={toggleModal} width="400px" height="500px">
                <form
                    onChange={(e) => {
                        if (bot.panel_status == "offline") {
                            toast.error("پنل بات خاموش میباشد")
                            return
                        }
                        const radioName = e.target.value
                        const data = {
                            radioName: radioName,
                            botId: bot.id,
                        }
                        toast
                            .promise(changeBotPlaying(data), {
                                pending: "درحال تغییر",
                                success: "تغییر داده شد",
                                Error: "Error",
                            })
                            .catch((err) => {
                                console.error(err)
                            })
                    }}
                >
                    <div class="list flex-grow overflow-hidden">
                        <table>
                            <tbody>
                                {radioList &&
                                    radioList.map((item, index) => {
                                        return (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>
                                                    <label for={`radio-${item.id}`}>{item.name}</label>
                                                </td>
                                                <td className="text-left">
                                                    <input
                                                        id={`radio-${item.id}`}
                                                        type="radio"
                                                        name="radio"
                                                        value={item.name}
                                                        class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800  dark:bg-gray-700 dark:border-gray-600 focus:outline-none"
                                                        defaultChecked={item.name == bot.playing ? true : false}
                                                    />
                                                </td>
                                            </tr>
                                        )
                                    })}
                            </tbody>
                        </table>
                    </div>
                </form>
            </MyModal>
        </>
    )
}

export default SelectRadioModal
